// For handling responses from the server
// and generating toast messages
export function formatErrorResponse(response) {
  const data = response?.data;
  var text = '';

  var keysToRemoveFromErrorMessage = [
    'message',
    'answers.file uploads.file_upload',
    'payment method',
  ];

  var keysToReplaceWithinErrorMessage = {
    'email_address.email_address': {
      value: 'Email Validation Error:',
      capitalizeMessage: false,
    },
  };

  for (var key in data) {
    // add space if multiple error messages
    let isKeyReplaced = false;
    if (text.length > 0) {
      text += ' ';
    }

    if (text != 'message') {
      var modifiedKey = key?.replace('_', ' ');
      modifiedKey =
        modifiedKey?.charAt(0)?.toUpperCase() + modifiedKey?.slice(1);
      // The word "Message" is prevented from being added in the text to be displayed.
      // if(modifiedKey != 'Message' && modifiedKey !== 'Payment method' && modifiedKey !== 'Answers.file uploads.file_upload') {
      if (keysToRemoveFromErrorMessage?.includes(key) === false) {
        if (
          Object.keys(keysToReplaceWithinErrorMessage)?.includes(key) === true
        ) {
          isKeyReplaced = true;
          text += keysToReplaceWithinErrorMessage?.[key]?.value + ' ';
        } else {
          text += modifiedKey + ' ';
        }
      }
    }
    var error_messages = data?.[key];
    if (Array.isArray(error_messages)) {
      // It's an array of messages associated with the key
      for (var val of error_messages) {
        if (
          isKeyReplaced === false ||
          keysToReplaceWithinErrorMessage?.[key]?.capitalizeMessage === true
        ) {
          text += val?.[0]?.toUpperCase() + val?.slice(1);
        } else {
          text += val;
        }
      }
    } else if (Number.isInteger(error_messages)) {
      // It's a number, just return the number.
      text += error_messages;
    } else {
      // It's not an array, just a provided string which the identity
      // service may provide instead
      if (error_messages !== null || error_messages !== undefined) {
        text +=
          error_messages?.charAt(0)?.toUpperCase() + error_messages?.slice(1);
      }
    }
  }
  console.log('ERROR NOTIFICATION TEXT: ' + text);
  return text;
}

// When the server response is an error, we need to format the response
// body into a readable string.  Depending on the status code of the response,
// we need to handle the response data differently.
function toastErrorResponse(app, response) {
  if (response?.status == 422) {
    app?.$toast?.open({
      message: formatErrorResponse(response),
      type: 'info',
      position: 'top-right',
      duration: 5000,
    });
  } else if (response?.status == 504) {
    app?.$toast?.open({
      message:
        'The server response timed out.  Please try your request again.  If this error continues, please contact service@highway.com.',
      // type: 'error',
      position: 'top-right',
      duration: '5000',
    });
  } else if (response?.status == 502) {
    app?.$toast?.open({
      message:
        'The server response timed out.  Please try your request again.  If this error continues, please contact service@highway.com.',
      // type: 'error',
      position: 'top-right',
      duration: 5000,
    });
  } else if (response?.status == 403) {
    app?.$toast?.open({
      message:
        'Unable to perform the action requested (403).  If you received this message in error, please contact service@highway.com',
      // type: 'error',
      position: 'top-right',
      duration: 5000,
    });
  } else {
    // Need to handle multiple error messages
    throw 'unsupported error response';
  }
}
// A successful toast response with the message provided
function toastSuccessResponse(app, message) {
  app?.$toast?.open({
    message: message,
    type: 'success',
    position: 'top-right',
    duration: 5000,
  });
}

// Return boolean indicating if the response was a success code
export function isSuccessfulServerResponse(response) {
  return [200, 201, 204].includes(response?.status);
}

// Function to handle toasting the response in the case of both
// error and success; if successMessage is null then we skip showing a
// message
export function toastResponse(app, response, successMessage) {
  if (isSuccessfulServerResponse(response)) {
    if (successMessage && successMessage?.length > 0) {
      return toastSuccessResponse(app, successMessage);
    } else {
      return true;
    }
  } else {
    return toastErrorResponse(app, response);
  }
}

// NOTE ON BELOW: Use toastRepsonseInSetup within any component's setup() function
// In the component, you'll need to import useToast and toastRepsonseInSetup:
// import { useToast } from 'vue-toast-notification';
// import { toastResponseInSetup } from "@/common/handleServerResponse"
// In the setup() function, you'll need to set the toast variable:
// const toast = useToast();
// Then you can call toastResponseInSetup within the setup() function:
// toastResponseInSetup(toast, res, 'Insert success message here')

// When the server response is an error, we need to format the response
// body into a readable string.  Depending on the status code of the response,
// we need to handle the response data differently.
function toastErrorResponseInSetup(toast, response) {
  if (response?.status == 422) {
    toast?.open({
      message: formatErrorResponse(response),
      // type: 'error',
      position: 'top-right',
      duration: 5000,
    });
  } else if (response?.status == 504) {
    toast?.open({
      message:
        'The server response timed out.  Please try your request again.  If this error continues, please contact service@highway.com.',
      // type: 'error',
      position: 'top-right',
      duration: '5000',
    });
  } else if (response?.status == 502) {
    toast?.open({
      message:
        'The server response timed out.  Please try your request again.  If this error continues, please contact service@highway.com.',
      // type: 'error',
      position: 'top-right',
      duration: 5000,
    });
  } else if (response?.status == 403) {
    toast?.open({
      message:
        'Unable to perform the action requested (403).  If you received this message in error, please contact service@highway.com',
      // type: 'error',
      position: 'top-right',
      duration: 5000,
    });
  } else {
    // Need to handle multiple error messages
    throw 'unsupported error response';
  }
}
// A successful toast response with the message provided
function toastSuccessResponseInSetup(toast, message) {
  toast?.open({
    message: message,
    type: 'success',
    position: 'top-right',
    duration: 5000,
  });
}

// Function to handle toasting the response in the case of both
// error and success; if successMessage is null then we skip showing a
// message
export function toastResponseInSetup(toast, response, successMessage) {
  if (isSuccessfulServerResponse(response)) {
    if (successMessage && successMessage?.length > 0) {
      return toastSuccessResponseInSetup(toast, successMessage);
    } else {
      return true;
    }
  } else {
    return toastErrorResponseInSetup(toast, response);
  }
}
